import { Plus, X } from "lucide-react";

// Copilot logo icon (ring with gradient)
function CopilotLogoIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5V20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20V17.5C14.1421 17.5 17.5 14.1421 17.5 10Z"
        fill="url(#paint0_radial_header)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_header"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.90625 18.4375) rotate(-45) scale(20.3293 18.4021)"
        >
          <stop stopColor="#6015E9" />
          <stop offset="0.675968" stopColor="#3448AE" />
          <stop offset="1" stopColor="#5EDAC3" />
        </radialGradient>
      </defs>
    </svg>
  );
}

interface ChatHeaderProps {
  onNewChat?: () => void;
  onClose?: () => void;
}

export function ChatHeader({ onNewChat, onClose }: ChatHeaderProps) {
  return (
    <div className="flex items-right justify-between px-6 py-3 border-b border-[#EDEBE9] bg-white h-14 shrink-0">
      <div className="flex gap-2 items-center">
        {onClose && (
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-2xl transition-colors"
            title="Close"
          >
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
      <div className="flex gap-2 items-center">
        {onNewChat && (
          <button
            onClick={onNewChat}
            className="flex items-center gap-1 px-3 py-1.5 text-sm font-normal rounded-2xl transition-all hover:brightness-90"
            style={{ 
              backgroundColor: 'rgba(216, 225, 255, 0.25)', 
              border: '1px solid #3448AE',
              color: '#3448AE'
            }}
            title="New Conversation"
          >
            <Plus className="w-4 h-4" />
            <span>New Conversation</span>
          </button>
        )}
      </div>
    </div>
  );
}
